import { ElMessage } from "element-plus"
// import i18n from '@/i18n'
import { EpPropMergeType } from "element-plus/lib/utils"
// const { t } = i18n.global

// 预览接口基础路径
// export const vodPlusBaseUrl = 'http://120.76.177.238:8304' // 测试服
export const vodPlusBaseUrl = 'http://metamango.org:8304'  // 正式服

export const isString = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'String'
}
export const isArray = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Array'
}
export const isObject = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Object'
}
export const isBoolean = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean'
}
export const isNumber = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Number'
}
// 判断是否是函数
export const isFunction = (o:any) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'Function'
}

// 是否空数组
export const isEmptyArray = (arr: any) => {
  if(!arr) return true
  return Array.isArray(arr) ? arr.length <= 0 : true
}

// 是否空对象,不是对象的默认为空对象
export const isEmptyObj = (obj: any) =>{
  return isObject(obj) ? Object.keys(obj).length === 0 : true
}

/**
 * 
 * @param {*} type 提示类型
 * @param {*} tips 提示消息
 * @param {Boolean} isT  是否翻译
 */
 export const elMessage = (type="success", tips="", isT=true, {showClose= false, duration= 3000,...other} = {}) => {
  ElMessage({
    type: type as EpPropMergeType<StringConstructor, "success" | "warning" | "info" | "error", unknown> | undefined,
    //message: isT ? (tips ? t(tips) : t('System Error')) : tips, //i18n安装就用这行
    message: isT ? (tips ? tips : 'System Error') : tips,
    grouping: true,
    showClose,
    duration,
    ...other
  })
}

// 获取字符串占的宽度
export function getTextWidth(str,strStyle?) {
  let width = 0;
  let html = document.createElement('span');
  html.innerText = str;
  html.className = 'getTextWidth';
  if(strStyle) {
    if(strStyle.fontSize) html.style.fontSize = strStyle.fontSize
    if(strStyle.fontWeight) html.style.fontWeight = strStyle.fontWeight
  }
  document.querySelector('body').appendChild(html);
  let classDom = document.querySelector('.getTextWidth') as any
  width = classDom.offsetWidth;
  document.querySelector('.getTextWidth').remove();
  return width;
}